module.exports = __webpack_public_path__ + "static/media/LogoGenerali.4c3b21e9.png";